import { TextButton } from "@/src/components/links/components/TextButton";
import { TextLinkType } from "@/src/components/links/types";
import { Body8 } from "@/src/components/typography/components/Body";
import clsx from "clsx";
import useVerificationCodeTimeOut from "../hooks";

type Props = {
  onResend: () => void;
  enableTimeout?: boolean;
  className?: string;
};

const ResendVerificationCodeText: React.FC<Props> = ({
  onResend,
  enableTimeout = true,
  className,
}) => {
  const { secondsLeft, toggleEnabled, enabled } =
    useVerificationCodeTimeOut(enableTimeout);

  return (
    <div className={clsx("dark flex flex-col items-center w-full", className)}>
      <Body8 className="text-gray-350">
        Didn&apos;t receive it?&nbsp;
        {enabled ? (
          <>Resend Code in {secondsLeft}s</>
        ) : (
          <TextButton
            onClick={() => {
              onResend();
              toggleEnabled(true);
            }}
            disabled={!enableTimeout}
            size={"sm"}
            linkType={
              enableTimeout ? TextLinkType.primary : TextLinkType.disabled
            }
          >
            Resend Code
          </TextButton>
        )}
      </Body8>
    </div>
  );
};

export default ResendVerificationCodeText;
